import React, { useRef, useEffect, useState, forwardRef, useImperativeHandle } from 'react'
import { Row, Col, Input } from 'antd'
import { useSelector } from 'react-redux'
import { apiTagValidation, readNfcUid } from '../../../services/tag/tag'
import { modalError } from '../../../utils/modalUtils'
import { clearAuthentication, redirectURL } from '../../../utils/authHelp'
import { handleChange, formatMessage, languageObj, addZero } from '../../../utils/common'
let instance1 = null
let instance2 = null
let instance4 = null
let sendErr = {}
let errorNumRef = 0
let intervalRef = null
let interFlag = false
const TagPage = forwardRef((props, ref) => {
  const inputRef = useRef(null)
  const [intervalFlag, setIntervalFlag] = useState(false)
  // const [isBlur, setIsBlur] = useState(false)
  const [upcValue, setUpcValue] = useState('')
  const [nfcValue, setNfcValue] = useState('')
  const [actualTagTypeObj, setActualTagTypeObj] = useState({
    tagType: ''
  })
  // const [themeObj, setThemeObj] = useState({ width: 750, height: 400, padding: 24 })
  // const deviceSize = useSelector(state => state.commonStore.deviceSize)
  const commonStore = useSelector(state => state.commonStore)
  const languageState = useSelector(state => state.commonStore.language)

  useEffect(() => {
    // 防止切换语言后重复NFC报错不切换
    if (intervalRef) {
      clearInterval(intervalRef)
    }
    commonStore.languageObj = languageObj[languageState]
    // 启用定时器
    setIntervalFlag(!interFlag)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageState])
  useImperativeHandle(ref, () => {
    return {
      clearInputs: () => {
        // 清空数据
        setUpcValue('')
        setNfcValue('')
        // 获取焦点
        inputRef.current.focus({
          cursor: 'all'
        })
      },
      inputBlur: () => {
        inputRef.current.blur()
      },
      setTimes: () => {
        // 启用定时器
        setIntervalFlag(!interFlag)
      }
    }
  })

  useEffect(() => {
    // setThemeObj({ width: 500 * deviceSize, height: 266 * deviceSize, padding: 16 * deviceSize })
    inputRef.current.focus({
      cursor: 'all'
    })
    window.addEventListener('keydown', onKeyDownBtn) // 添加全局事件
    return () => {
      window.removeEventListener('keydown', onKeyDownBtn) // 销毁
      // 关闭定时器
      clearInterval(intervalRef)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onKeyDownBtn = e => {
    switch (e.keyCode) {
      case 13:
        if (instance1) {
          instance1.destroy()
          instance1 = null
          errorNumRef = 0
          // 清空数据
          setUpcValue('')
          setNfcValue('')
          // 获取焦点
          inputRef.current.focus({
            cursor: 'all'
          })
          if (sendErr.errorCode === '401') {
            clearAuthentication()
            window.location.href = redirectURL
          }
          sendErr = {}
          // 启用定时器
          setIntervalFlag(!interFlag)
        }
        if (instance2) {
          instance2.destroy()
          instance2 = null
          errorNumRef = 0
          if (sendErr.errorCode === '401') {
            clearAuthentication()
            window.location.href = redirectURL
          }
          sendErr = {}
          // 启用定时器
          setIntervalFlag(!interFlag)
        }
        if (instance4) {
          instance4.destroy()
          instance4 = null
          // 清空数据
          setUpcValue('')
          setNfcValue('')
          // 获取焦点
          inputRef.current.focus({
            cursor: 'all'
          })
          // 启用定时器
          setIntervalFlag(!interFlag)
        }
        break
      default:
        break
    }
  }
  const onKeyDownCpu = e => {
    switch (e.keyCode) {
      case 13:
        sendNfcAndSku()
        break
      default:
        break
    }
  }
  const onKeyDown = e => {
    switch (e.keyCode) {
      case 13:
        // sendNfcAndSku()
        apiTagValidationFun()
        break
      default:
        break
    }
  }

  const apiTagValidationFun = () => {
    if (!nfcValue) {
      return
    }
    apiTagValidation({ tagUid: nfcValue })
      .then(res => {
        if (res.errorCode === '200') sendNfcAndSku()
      })
      .catch(error => {
        // 关闭定时器
        clearInterval(intervalRef)
        sendErr = error
        if (errorNumRef === 0) {
          errorNumRef = 1
          if (error.errorCode === '421') {
            instance1 = modalError(
              {
                content: formatMessage(commonStore, 'languageObj.nsptagLocale.NFCUIDInvalid')
              },
              () => {
                instance1 = null
                errorNumRef = 0
                sendErr = {}
                // 启用定时器
                setIntervalFlag(!interFlag)
              }
            )
          }
          if (error.errorCode === '442') {
            instance1 = modalError(
              {
                content: formatMessage(commonStore, 'languageObj.nsptagLocale.NFCUIDDisabled')
              },
              () => {
                instance1 = null
                errorNumRef = 0
                sendErr = {}
                // 启用定时器
                setIntervalFlag(!interFlag)
              }
            )
          }
          if (error.errorCode === '401') {
            instance1 = modalError(
              {
                content: formatMessage(commonStore, 'languageObj.commonLocale.tokenInvalid')
              },
              () => {
                instance1 = null
                errorNumRef = 0
                sendErr = {}
                clearAuthentication()
                window.location.href = redirectURL
              }
            )
          }
        }
      })
  }

  const sendNfcAndSku = () => {
    inputRef.current.focus({
      cursor: 'all'
    })
    if (upcValue && nfcValue && actualTagTypeObj.tagType) {
      props.tagItem(upcValue, nfcValue, actualTagTypeObj.tagType)
    }
  }

  useEffect(() => {
    if (nfcValue?.length !== 0) apiTagValidationFun()
    // sendNfcAndSku()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nfcValue])
  useEffect(() => {
    props.confirmDialogMac()
    interFlag = intervalFlag
    getNfcByTimes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intervalFlag])

  const getNfcByTimes = () => {
    if (intervalRef) {
      clearInterval(intervalRef)
    }
    intervalRef = setInterval(() => {
      fetNFCFun()
    }, 1400)
  }
  const fetNFCFun = () => {
    if (intervalRef) {
      clearInterval(intervalRef)
    }
    readNfcUid({})
      .then(response => {
        let res = response.resultData
        if (response.errorcode === '200') {
          if (res && res.length > 0) {
            if (res.length > 1) {
              setNfcValue('')
              setActualTagTypeObj({
                tagType: ''
              })
              clearInterval(intervalRef)
              if (errorNumRef === 0) {
                errorNumRef = 1
                instance2 = modalError(
                  {
                    content: formatMessage(commonStore, 'languageObj.nsptagLocale.multipleNfcError')
                  },
                  () => {
                    errorNumRef = 0
                    instance2 = null
                    // 启用定时器
                    setIntervalFlag(!interFlag)
                  }
                )
              }
            } else {
              if (res[0].tagType && res[0].tagType.length > 0) {
                var str = res[0].tagType
                let result = ''
                if (str && str !== 'null') {
                  for (let i = 0; i < str.length; i += 2) {
                    let strcode = String.fromCharCode(parseInt(str.slice(i, i + 2), 16))
                    result += strcode
                  }
                }
                setActualTagTypeObj({
                  tagType: result
                })
              } else {
                setActualTagTypeObj({
                  tagType: ''
                })
              }
              setNfcValue(res[0].UID)
              // 启用定时器
              setIntervalFlag(!interFlag)
            }
          } else {
            setNfcValue('')
            setActualTagTypeObj({
              tagType: ''
            })
            // 启用定时器
            setIntervalFlag(!interFlag)
          }
        } else {
          setNfcValue('')
          setActualTagTypeObj({
            tagType: ''
          })
          props.confirmDialog()
        }
      })
      .catch(error => {
        // clearInterval(intervalRef)
        props.confirmDialog()
      })
  }

  return (
    <div style={{ height: '100%' }}>
      <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
        <Row>
          <Col
            style={{ textAlign: 'right', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
            span={2}
          >
            UPC：
          </Col>
          <Col span={9}>
            <Input
              value={upcValue}
              ref={inputRef}
              onChange={e =>
                handleChange(e, {
                  setState: value => {
                    const newValue = value ? addZero(value, 14) : value
                    setUpcValue(newValue)
                  }
                })
              }
              placeholder={formatMessage(commonStore, 'languageObj.nsptagLocale.pleaseScan') + 'UPC'}
              allowClear
              onKeyUp={e => onKeyDownCpu(e)}
              // onBlur={e => onBlurFun(e)}
              // onFocus={e => onFocusFun(e)}
            />
          </Col>
          <Col
            style={{ textAlign: 'right', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
            span={4}
          >
            NFC UID：
          </Col>
          <Col span={9}>
            <Input
              value={nfcValue}
              onChange={e => handleChange(e, { setState: setNfcValue })}
              placeholder={formatMessage(commonStore, 'languageObj.nsptagLocale.pleaseScan') + 'NFC'}
              allowClear
              readOnly
              onKeyUp={e => onKeyDown(e)}
            />
          </Col>
        </Row>
      </div>
    </div>
  )
})
export default React.memo(TagPage)
